<style lang="css" scoped>
td.bg-yellow:hover {
  cursor: pointer;
}
.align-middle {
    display: flex;
    align-items: center;
}
</style>

<template>
	<div>
		<div class="d-flex align-items-center">
			<div>
				<h1 class="page-header"><i class="fa fa-calendar"></i> Foglalások <small></small></h1>
			</div>
			<div class="ms-auto">
				<button class="btn btn-success btn-rounded px-4 rounded-pill mx-2" v-b-modal.addBookingModal><i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új foglalás</button>
				<button class="btn btn-danger btn-rounded px-4 rounded-pill" @click="$router.push('/bookings/deleted')"><i class="fa fa-trash fa-lg me-2 ms-n2 text-danger-900"></i> Törölt foglalások</button>
			</div>
		</div>
		<hr>
		<panel title="Foglalások">
			<template slot="beforeBody">
				<div class="panel-toolbar">
					<Loading v-if="!guesthouses"></Loading>
					<div v-else>
						<div class="row text-end">
							<help helpId="bookingFilterHelp" title="Foglalás szűrés" text="Válasszon hónapot, Ha nem választ Vendégházat mindet visszakapja a Szűrés gombra kattintva frissül a lista"></help>
						</div>
						<div class="row">
							<div class="col col-md-1">
								<datepicker placeholder="Válassz Hónapot" input-class="form-control bg-white" minimum-view="month" :format="customFormatter" :language="hu" v-model="filter.date"></datepicker>
							</div>
							<div class="col col-md-3" v-if="filter.date && user && user.role_id == 1">
								<v-select v-model="filter.guesthouse_id" :options="guesthouses" :reduce="(option) => option.id" label="name" style="min-width:300px;">
									<template #search="{attributes, events}">
										<input
											class="vs__search"
											:required="!filter.guesthouse_id"
											v-bind="attributes"
											v-on="events"
											:placeholder="!filter.guesthouse_id ? 'Összes Vendégház!' : ''"
										/>
									</template>
								</v-select>
							</div>
							<div class="col col-md-1">
								<button class="btn btn-success" @click="getFiltered()"><i class="fa fa-search"></i> Szűrés</button>
							</div>
							<div class="col col-md-1"></div>
							<div class="col col-md-1 align-middle">Foglalás keresése</div>
							<div class="col col-md-1"><input type="text" class="form-control bg-white" v-model="targetBooking"></div>
							<div class="col col-md-1"><button class="btn btn-success" @click="jumpToBooking()"><i class="fa fa-search"></i> Ugrás</button></div>
						</div>

					</div>
				</div>
			</template>
			<Loading v-if="!selected_guesthouses_with_tds"></Loading>
			<template v-else>
				<div>
					<span class="fw-bold mx-1"><i class="fa fa-circle text-warning"></i> leadva</span>
					<span class="fw-bold mx-1"><i class="fa fa-circle text-primary"></i> fizetve</span>
				</div>
				<div class="overflow-auto" style="max-height:60vh;">
					<div v-for="(guesthouse,id) in selected_guesthouses_with_tds" :key="id">
						<h3>{{ guesthouse.name }}</h3>
						<div class="table-responsive">
							<table class="table table-bordered">
								<thead>
									<tr>
										<th>Szoba</th>
										<th style="width:40px;" class="bg-dark text-white text-center" v-for="i in days" :key="i">{{i}}</th>
										<th class="text-center">Éj</th>
										<th class="text-center">%</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(room,id) in guesthouse.rooms" :key="id">
										<td>{{room.name}}</td>
										<td v-for="(cell,id) in room.tds" :key="id" 
										:colspan="cell.colspan" 
										:class="{'bg-warning': cell.status == 1, 'bg-primary': cell.status == 5, 'bg-yellow': hovered_booking_id && hovered_booking_id == cell.booking_id}" 
										class="text-center fw-bold" 
										:data-id="cell.booking_id" 
										@mouseover="setHoverClass($event,'add')" 
										@mouseleave="setHoverClass($event,'remove')" 
										@click="dateClickHandler(cell.booking_id)">
											{{cell.nights}}
										</td>
										<td>{{ room.utilization.nights }}</td>
										<td>{{ room.utilization.percentage }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</template>
		</panel>
		<b-modal id="addBookingModal" size="xl" dialog-class="mw-90-percent" hide-footer>
			<template slot="modal-header">
				<h4 class="modal-title">Új foglalás</h4>
				<help iconClass="mx-1" title="Új foglalás" text="Amennyiben admin ad le foglalást ugyanazt a varázslót használja de első lépésben felhasználót kell választania" devNotes="elso lepesben wizard guestset lekéri" helpId="newBookingHelp">
				</help>
				<a class="btn-close" @click="$bvModal.hide('addBookingModal')"></a>
			</template>
			<BookingWizard @finished="getFiltered"></BookingWizard>
		</b-modal>
	</div>
</template>

<script>
	import BookingWizard from '../booking/Booking.vue';
	import Booking from '../../apis/Booking';
	import Guesthouse from '../../apis/Guesthouse';
	import moment from 'moment';
	import {hu} from 'vuejs-datepicker/dist/locale'

	export default {
		components: {
			BookingWizard
		},
		data() {
			return {
				hu: hu,
				days:moment().daysInMonth(),
				startOfMonth:moment().startOf('month').format('YYYY-MM-DD'),
				hovered:null,
				hovered_booking_id:null,
				guesthouses:null,
				selected_guesthouses:null,
				filter:{
					guesthouse_id:null,
					date:moment().startOf('month').format('YYYY-MM-DD'),
				},
				statuses:null,
				targetBooking:null
			}
		},
		computed:{
			user(){
				return this.$store.state.user;
			},
			booking_filter(){
				return this.$store.state.booking_filter;
			},
			filter_date_formatted(){
				return this.filter.date ? moment(this.filter.date).format('YYYY-MM-DD') : null
			},
			selected_guesthouses_with_tds(){
				if(this.selected_guesthouses == null){
					return null;
				}else{
					return this.selected_guesthouses.map( s => ({
						name: s.guesthouse_name,
						rooms: s.rooms.map( r => ({
							name: r.room_name,
							utilization: {
								nights:r.bookings.reduce((a,b) => { return a + parseInt(b.nights_in_month) },0),
								percentage:((r.bookings.reduce((a,b) => { return a + parseInt(b.nights_in_month) },0) / this.days) * 100).toFixed(2),
							},
							tds: this.getTds(r)
						}))
					}));
				}
			}
		},
		created() {
			this.filter = this.booking_filter;
			
			this.getFiltered();
			/*Booking.actual()
			.then(response => {
				this.selected_guesthouses = response.data;
			});*/
			Guesthouse.index()
			.then(response => {
				this.guesthouses = response.data;
			});
			
			this.statuses = JSON.parse(localStorage.getItem('constants')).status;
		},
		methods: {
			setHoveredBookingId(id){
				this.$set(this,'hovered_booking_id',id);
			},
			setHoverClass(event, action){
				let booking_id = event.currentTarget.getAttribute('data-id');
				if(booking_id != null){
					var list;
					list = document.querySelectorAll('[data-id="'+booking_id+'"]');
					for (var i = 0; i < list.length; ++i) {
						if(action == 'add'){
							list[i].classList.add('bg-yellow');
						}
						else{
							list[i].classList.remove('bg-yellow');
						}
					}
				}
			},
			getTds(room){
				//console.log('lefut a getTd',this.days)
				let tds = [];
				for (var i = 1; i <= this.days; i++) {
					let is_booked = this.isDateInBookings(this.calcDate(i),room.bookings);
					if(!is_booked){
						tds.push({});
					}else{
						tds.push(is_booked);
						i += is_booked.colspan-1;
					}
				}
				return tds;
			},
			isDateInBookings(date,bookings){
				//console.log('lefut az is DateInBookings')
				let booked = false;
				bookings.forEach(b => {
					if(moment(date).isBetween(b.arrive_at, b.leave_at, 'days', '[)')){
						booked = {
							booking_id: b.booking_id,
							colspan: parseInt(b.nights_in_month),
							status: b.status,
							nights: b.nights
						};
					}
				});
				return booked;
			},
			getFiltered(){
				Booking.actual(this.filter_date_formatted,this.filter.guesthouse_id)
				.then(response => {
					this.selected_guesthouses = null;
					this.$set(this,'days',moment(this.filter_date_formatted).daysInMonth())
					this.$set(this,'startOfMonth',moment(this.filter_date_formatted).startOf('month').format('YYYY-MM-DD'))
					this.selected_guesthouses = response.data;
					this.$forceUpdate(this.selected_guesthouses);
					this.$store.commit('updateBookingFilter',this.filter);
				})
			},
			customFormatter(date) {
				return moment(date).format('YYYY-MM');
			},
			dateClickHandler(booking_id){
				if(booking_id){
					this.$router.push('/bookings/'+booking_id)	
				}
			},
			calcDate(day){
				return moment(this.startOfMonth).startOf('month').set('date',day).format('YYYY-MM-DD');
			},
			isFirstInBooking(booking,date){
				return moment(date).isSame(moment(booking.arrival))  || (moment(booking.arrival).isBefore(moment(this.startOfMonth)) && moment(date).isSame(moment(this.startOfMonth)))
			},
			isFirstInBookingG(booking,date){
				return moment(date).isSame(moment(booking.arrive_at))  || (moment(booking.arrive_at).isBefore(moment(this.startOfMonth)) && moment(date).isSame(moment(this.startOfMonth)))
			},
			isBooked(room_id,date){
				let booked = false;
				this.events.rooms.find(r => r.id == room_id).bookings.forEach(b => {
					if(moment(date).isBetween(b.arrival, b.departure, 'days', '[)')){
						booked = b;
					}
				});
				return booked;
			},
			isBookedD(guesthouse_id,room_id,date){
				let booked = false;
				this.selected_guesthouses.find(g => g.guesthouse_id == guesthouse_id).rooms.find(r => r.id == room_id).bookings.forEach(b => {
					if(moment(date).isBetween(b.arrive_at, b.leave_at, 'days', '[)')){
						booked = b;
					}
				});
				return booked;
			},
			jumpToBooking(){
				if(this.targetBooking){
					this.$router.push('/bookings/'+this.targetBooking)
					this.$nextTick(() => {
						this.targetBooking = null;
					});
				}
			}
		}
	};
</script>